import { useAuthStore } from "@src/features/auth/auth-store";
import { useImpersonationStore } from "@src/features/auth/impersonation-store";
import { useIsSupportUser } from "@src/features/tenants";
import { inheritedAccessReason, type InheritedAccessReason } from "../utils/inherited-access-reason";

/**
 * Whether the signed-in user's access comes from the support role or a
 * Microsoft group, which stored-grant recipients (notifications, report
 * emails) never include. `null` when it doesn't, and while impersonating:
 * the page then shows the impersonated user's settings, and the signed-in
 * support user's own access says nothing about theirs.
 */
export function useInheritedAccessReason(): InheritedAccessReason | null {
  const accessToken = useAuthStore((state) => state.accessToken);
  const isImpersonating = useImpersonationStore((state) => state.impersonatedUserId !== null);
  const isSupportUser = useIsSupportUser();
  return isImpersonating ? null : inheritedAccessReason(isSupportUser, accessToken);
}
